import React, { useContext, useState, useEffect } from "react";
import { Trans } from "react-i18next";
import { useBaseModal } from "services";
import { useForm } from "react-hook-form"
import { NotificationManager } from "react-notifications";
import { Col, Row, Button, FormGroup, Form, Label} from "reactstrap";
import { PendingButton } from "components/common";
import EmployeeContext from "contexts/EmployeeContext";

const List = ({ t, client }) => {
  const [data, setData] = useState(null);
  const [SetTerminateModal, TerminateToggle, TerminateModal] = useBaseModal();
  const [selectedContract, setSelectedContract] = useState(null);
  const { employee } = useContext(EmployeeContext);

  const { control, handleSubmit, register } = useForm({})

  useEffect(
    () =>
      void (async () => {
        if (!employee) return;
        const data = await client
          .get(`employees/${employee.id}/contracts`)
          .get("data");
        if (data.length > 0) setData(data);
      })(),
    [employee]
  );

  const preTerminate = (contract_id) => {
    setSelectedContract(contract_id)
    TerminateToggle();
  }

  const terminate = (data) => {
    client
      .post(`employees/${employee.id}/contracts/${selectedContract}/end_contract`, data)
      .then(() => {
        TerminateToggle();
        NotificationManager.success("Successfully sent the termination request");
      }).catch(() => {
        NotificationManager.error("Failed to send the termination request");
      });
  }

  if (!data) return null;

  return (
    <div>
      <h4>
        <Trans>My Contracts</Trans>
      </h4>
      <table className="table table-striped employee-holiday-table">
        <thead>
          <tr>
            <th>
              <Trans>Start Date</Trans>
            </th>
            <th>
              <Trans>End Date</Trans>
            </th>
            <th>
              <Trans>Status</Trans>
            </th>
            <th>
              <Trans>Salary</Trans>
            </th>
            <th>
              <Trans>Position</Trans>
            </th>
            <th><Trans>Actions</Trans></th>
          </tr>
        </thead>
        <tbody className="small">
          {data.map((i) => (
            <tr key={i.id}>
              <td>{i.start_date}</td>
              <td>{i.end_date}</td>
              <td>{i.status_label}</td>
              <td>{i.salary}</td>
              <td>{i.position}</td>
              <td>
                <PendingButton onClick={() => preTerminate(i.id)} className="btn btn-danger" disabled={i.status!=="active"}>
                  <Trans>End</Trans>
                </PendingButton>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <TerminateModal title={t("Contract termination request")}>
          <Form onSubmit={handleSubmit(terminate)}>
            <Row>
              <Col className="col-12 my-2">
                <FormGroup label="Details">
                  <Label><Trans>Reason</Trans></Label>
                  <textarea name="details" id="details"{...register("details", { required: false })} className="form-control"></textarea>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col className="align-self-end text-right my-2 col-12">
                <FormGroup>
                  <Button color="success">
                    <Trans>Request</Trans>
                  </Button>
                </FormGroup>
              </Col>
            </Row>
          </Form>
      </TerminateModal>
    </div>
  );
};

export default List